/* Start Section dose_zive_23may_pdp_no_claims_lp_L8ArtN */
document.addEventListener('DOMContentLoaded',function(){const popup__button_text_text_class_section=document.querySelector('.popup_button_text_text_class_section');const dialog_modal=document.querySelector('.dialog-modal');const dialog_content=document.querySelector('.dialog-modal-content');popup__button_text_text_class_section.addEventListener("click",function(){dialog_modal.style.display="flex";});const dialog_close=dialog_modal.querySelector('.dialog_close');dialog_close.addEventListener("click",function(){dialog_modal.style.display="none";});dialog_modal.addEventListener('click',function(event){if(!dialog_content.contains(event.target)){dialog_modal.style.display="none";}});});
/* End Section dose_zive_23may_pdp_no_claims_lp_L8ArtN */
/* Start Section dose_zive_23may_banner_wTcGnK */
document.addEventListener("DOMContentLoaded",function(){const mainPictureTag=document.querySelector('.section-template--dose_zive_23may_banner_wTcGnK .main_picture-tag');if(mainPictureTag){const width=mainPictureTag.offsetWidth;const newWidth=width*0.4+"px";const videoPlayer=document.querySelector('.section-template--dose_zive_23may_banner_wTcGnK .image_container video-player');if(videoPlayer){videoPlayer.style.width=newWidth;videoPlayer.style.height=newWidth;}}});
/* End Section dose_zive_23may_banner_wTcGnK */
document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();

            document.querySelector(this.getAttribute('href')).scrollIntoView({
                behavior: 'smooth'
            });
        });
    });
});
if (!customElements.get('carousel-slider')) {
class CarouselSlider extends HTMLElement {
  constructor() {
    super();
    this.activeIndex = 0;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.cacheElements();
    this.bindEvents();
    this.scrollToMediaItem(this.activeIndex);
  }

  cacheElements() {
    this.mainMedia = this.querySelector('main-slider');
    this.thumbSlider = this.querySelector('thumb-slider');
    this.thumbVertical = this.thumbSlider?.dataset.vartical;
    this.pagenation = this.querySelector('pagenation');
    this.mediaItems = this.mainMedia?.querySelectorAll('main-slider-slide') || [];
    this.thumbItems = this.thumbSlider?.querySelectorAll('thumb-slider-slide') || [];
    this.pageItems = this.pagenation?.querySelectorAll('button.page-media-item') || [];
  }

  bindEvents() {
    const mediaBtnNext = this.querySelector('.media-next');
    const mediaBtnPrev = this.querySelector('.media-prev');

    mediaBtnNext?.addEventListener('click', () => this.goToNext());
    mediaBtnPrev?.addEventListener('click', () => this.goToPrev());

    this.thumbItems.forEach((thumb, index) => {
      thumb.addEventListener('click', () => this.scrollToMediaItem(index));
    });
    
    this.pageItems.forEach((page, index) => {
      page.addEventListener('click', () => this.scrollToMediaItem(index));
    });
    
    let scrollTimeout = null;
    this.mainMedia?.addEventListener('scroll', () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => this.handleScrollSnap(), 200);
    });
    
    const updateThumbSliderHeight = () => {
      if (this.thumbVertical && window.innerWidth > 768) {
        this.thumbSlider.style.maxHeight = this.mainMedia.offsetHeight + 'px';
      } else {
        this.thumbSlider.style.maxHeight = ''; // Optional: reset height on small screens
      }
    };
  
    setTimeout(updateThumbSliderHeight, 200);
  
    window.addEventListener('resize', () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(updateThumbSliderHeight, 200);
    });
  }

  handleScrollSnap() {
    const scrollLeft = this.mainMedia.scrollLeft;
    const itemWidth = this.mediaItems[0]?.clientWidth || 0;
    const offset = scrollLeft + this.mainMedia.offsetLeft;

    let closestIndex = 0;
    let minDiff = Infinity;
    this.mediaItems.forEach((item, i) => {
      const diff = Math.abs(item.offsetLeft - offset);
      if (diff < minDiff) {
        minDiff = diff;
        closestIndex = i;
      }
    });

    this.scrollToMediaItem(closestIndex);
  }

  goToNext() {
    if (this.activeIndex < this.mediaItems.length - 1) {
      this.scrollToMediaItem(this.activeIndex + 1);
    }
  }

  goToPrev() {
    if (this.activeIndex > 0) {
      this.scrollToMediaItem(this.activeIndex - 1);
    }
  }

  scrollToMediaItem(index) {
    if (!this.mediaItems.length) return;

    this.mediaItems[this.activeIndex]?.classList.remove('active');
    this.thumbItems[this.activeIndex]?.classList.remove('active');
    this.pageItems[this.activeIndex]?.classList.remove('active');

    this.activeIndex = index;

    this.mediaItems[this.activeIndex]?.classList.add('active');
    this.thumbItems[this.activeIndex]?.classList.add('active');
    this.pageItems[this.activeIndex]?.classList.add('active');

    const scrollLeft = this.mediaItems[this.activeIndex].offsetLeft - this.mainMedia.offsetLeft;
    this.mainMedia.scrollTo({ left: scrollLeft, behavior: 'smooth' });

    const thumbScroll = this.thumbItems[this.activeIndex].offsetLeft - this.thumbSlider.offsetLeft - ((this.thumbSlider.clientWidth / 2) - (this.thumbItems[this.activeIndex].clientHeight / 2));
    this.thumbSlider.scrollTo({ left: thumbScroll, behavior: 'smooth' });
  }

  refresh(index = 0) {
    this.activeIndex = index;
    this.cacheElements();
    this.bindEvents();
  }

  createCustomCarouselSlide(data, isThumbnail = false) {
    const slideTag = isThumbnail ? 'thumb-slider-slide' : 'main-slider-slide';
    const slideClass = isThumbnail ? 'thumb-media-item' : 'main-media-item';
    const slide = document.createElement(slideTag);
    slide.className = slideClass;
    slide.id = isThumbnail ? undefined : `wwai-media-${data.id}`;

    const img = document.createElement('img');
    img.src = isThumbnail ? `${data.src}&width=${data.width}` : data.src;
    img.alt = data.alt || "Image";
    img.width = data.width;
    img.height = data.height;
    img.loading = 'lazy';
    img.className = isThumbnail ? 'thumb-media-img' : 'main-media-img';

    const srcset = isThumbnail
      ? `${data.src}&width=${data.width} ${data.width}w`
      : [
          `${data.src}&width=352 352w`,
          `${data.src}&width=832 832w`,
          `${data.src}&width=1200 1200w`,
          `${data.src}&width=1920 1920w`,
          `${data.src}&width=2561 2561w`
        ].join(', ');

    img.setAttribute('srcset', srcset);
    img.setAttribute('sizes', '(min-width: 1536px) 1500px,(min-width: 1280px) 1250px,(min-width: 768px) 994px,(min-width: 768px) 708px,(min-width: 640px) 610px,100vw');

    if (isThumbnail) {
      slide.setAttribute('data-handle', `media-${data.id}`);
      slide.setAttribute('data-img-id', data.src);
    }

    slide.appendChild(img);
    return slide;
  }

  gotoSlide(index) {
    if (!this.mediaItems.length) return;

    if (index < 0) {
      const resolvedIndex = this.mediaItems.length + index;
      this.scrollToMediaItem(resolvedIndex);
    } else {
      this.scrollToMediaItem(index);
    }
  }

  clearSlides() {
    this.mainMedia.innerHTML = '';
    this.thumbSlider.innerHTML = '';
    this.mediaItems = [];
    this.thumbItems = [];
    this.activeIndex = 0;
  }
}

customElements.define('carousel-slider', CarouselSlider);
}
// class VideoPlayer extends HTMLElement {
//   constructor() {
//     super();
//     this.videos = this.querySelectorAll('video');
//     this.videoWeb = this.videos[0];
//     this.videoMob = this.videos[1];
//     this.playBtn = this.querySelector('.play-btn');
//     this.soundBtn = this.querySelector('.mute-btn');
//     this.disableClick = this.dataset.click;
//     if (this.disableClick) {
//       this.initEventListeners();
//     }
//   }

//   initEventListeners() {
//     this.videos.forEach(video => {
//       video.addEventListener('click', () => this.togglePlay(video));
//       video.addEventListener('ended', () => this.handleVideoEnded(video)); // Listen for the `ended` event
//     });

//     if (this.playBtn) {
//       this.playBtn.addEventListener('click', () => this.handlePlayButton());
//     }

//     if (this.soundBtn) {
//       this.soundBtn.addEventListener('click', () => this.toggleMute());
//     }

//     window.addEventListener('resize', () => this.handleResize());
//   }

//   togglePlay(video) {
//     if (video.paused) {
//       this.playVideo(video);
//     } else {
//       this.pauseVideo(video);
//     }
//   }

//   playVideo(video) {
//     this.videos.forEach(otherVideo => {
//       if (otherVideo !== video) otherVideo.pause();
//     });
//     video.play();
//     this.classList.add('played');
//   }

//   pauseVideo(video) {
//     video.pause();
//     this.classList.remove('played');
//   }

//   handlePlayButton() {
//     const targetVideo = window.innerWidth < 749 && this.videoMob ? this.videoMob : this.videoWeb;
//     if (targetVideo) this.togglePlay(targetVideo);
//   }

//   toggleMute() {
//     const targetVideo = window.innerWidth < 749 && this.videoMob ? this.videoMob : this.videoWeb;
//     if (targetVideo) {
//       targetVideo.muted = !targetVideo.muted;
//       this.soundBtn.classList.toggle('active', targetVideo.muted);
//     }
//   }

//   handleResize() {
//     if (!this.videoMob) return;

//     const isMobile = window.innerWidth < 749;
//     const targetVideo = isMobile ? this.videoMob : this.videoWeb;

//     this.videos.forEach(video => video.pause());
//     targetVideo.play();
//     targetVideo.pause(); // Ensure the video is ready for user interaction
//   }

//   handleVideoEnded(video) {
//     // Check if the video is not set to loop
//     if (!video.loop) {
//       this.classList.remove('played');
//     }
//   }
// }

// customElements.define('video-player', VideoPlayer);

(function () {
  // Check if the custom element is already defined
  if (!customElements.get('video-player')) {
    class VideoPlayer extends HTMLElement {
      constructor() {
        super();
        this.videos = this.querySelectorAll('video');
        this.videoWeb = this.videos[0];
        this.videoMob = this.videos[1];
        this.playBtn = this.querySelector('.play-btn');
        this.soundBtn = this.querySelector('.mute-btn');
        this.disableClick = this.dataset.click;

        if (this.disableClick) {
          this.initEventListeners();
        }
      }

      initEventListeners() {
        this.videos.forEach(video => {
          video.addEventListener('click', () => this.togglePlay(video));
          video.addEventListener('ended', () => this.handleVideoEnded(video)); // Listen for the `ended` event
        });

        if (this.playBtn) {
          this.playBtn.addEventListener('click', () => this.handlePlayButton());
        }

        if (this.soundBtn) {
          this.soundBtn.addEventListener('click', () => this.toggleMute());
        }

        window.addEventListener('resize', () => this.handleResize());
      }

      togglePlay(video) {
        if (video.paused) {
          this.playVideo(video);
        } else {
          this.pauseVideo(video);
        }
      }

      playVideo(video) {
        this.videos.forEach(otherVideo => {
          if (otherVideo !== video) otherVideo.pause();
        });
        video.play();
        this.classList.add('played');
      }

      pauseVideo(video) {
        video.pause();
        this.classList.remove('played');
      }

      handlePlayButton() {
        const targetVideo = window.innerWidth < 749 && this.videoMob ? this.videoMob : this.videoWeb;
        if (targetVideo) this.togglePlay(targetVideo);
      }

      toggleMute() {
        const targetVideo = window.innerWidth < 749 && this.videoMob ? this.videoMob : this.videoWeb;
        if (targetVideo) {
          targetVideo.muted = !targetVideo.muted;
          this.soundBtn.classList.toggle('active', targetVideo.muted);
        }
      }

      handleResize() {
        if (!this.videoMob) return;

        const isMobile = window.innerWidth < 749;
        const targetVideo = isMobile ? this.videoMob : this.videoWeb;

        this.videos.forEach(video => video.pause());
        targetVideo.play();
        targetVideo.pause(); // Ensure the video is ready for user interaction
      }

      handleVideoEnded(video) {
        // Check if the video is not set to loop
        if (!video.loop) {
          this.classList.remove('played');
        }
      }
    }

    // Define the custom element
    customElements.define('video-player', VideoPlayer);
  }
})();
